import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HerdComponent } from './pages/herd/herd.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { StartComponent } from './pages/start/start.component';
import { UdderComponent } from './pages/udder/udder.component';
import { AllPyramidsComponent } from './pages/all-pyramids/all-pyramids.component';
import { UdderResultComponent } from './pages/udder-result/udder-result.component';
import { PyramidPaths } from './models/pyramid.enum';

const routes: Routes = [
  {
    path: '',
    component: StartComponent,
  },
  {
    path: 'besattning',
    component: HerdComponent,
  },
  {
    path: 'juverhalsa',
    children: [
      { path: '', component: UdderComponent },
      { path: 'resultat', component: UdderResultComponent },
    ],
  },
  {
    path: 'pyramiderna',
    component: AllPyramidsComponent,
  },
  {
    path: PyramidPaths.Emergency,
    loadChildren: () => import('./modules/pyramid-emergency/pyramid-emergency.module').then((m) => m.PyramidEmergencyModule),
  },
  {
    path: PyramidPaths.CowBacteria,
    loadChildren: () => import('./modules/pyramid-cow-bacteria/pyramid-cow-bacteria.module').then((m) => m.PyramidCowBacteriaModule),
  },
  {
    path: PyramidPaths.EnvironmentBacteria,
    loadChildren: () =>
      import('./modules/pyramid-environment-bacteria/pyramid-environment-bacteria.module').then((m) => m.PyramidEnvironmentBacteriaModule),
  },
  {
    path: PyramidPaths.RobotCowBacteria,
    loadChildren: () =>
      import('./modules/pyramid-robot-cow-bacteria/pyramid-robot-cow-bacteria.module').then((m) => m.PyramidRobotCowBacteriaModule),
  },
  {
    path: PyramidPaths.RobotEnvironmentBacteria,
    loadChildren: () =>
      import('./modules/pyramid-robot-environment-bacteria/pyramid-robot-environment-bacteria.module').then(
        (m) => m.PyramidRobotEnvironmentBacteriaModule
      ),
  },
  {
    path: PyramidPaths.SummerPeak,
    loadChildren: () => import('./modules/pyramid-summer-peak/pyramid-summer-peak.module').then((m) => m.PyramidSummerPeakModule),
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
